import type {
  DeliveryState,
  FileTransfer,
  ExecutionMode,
  PreDeliveryAction,
  PostDeliveryAction,
  RetryConfig,
} from '../shared';
import type { Location } from '../Locations';

export interface Delivery {
  name: string;
  scheduledDelivery?: string | null;
  sourceLocation?: string;
  sourcePath?: string;
  targetLocation?: string;
  targetPath?: string;
  state: DeliveryState;
  statusMessage?: string;
  fileTransfers?: FileTransfer[];
  startTime?: string;
  endTime?: string;
}

export interface DeliveryDisplay {
  name: string;
  scheduledDelivery?: string | null;
  sourceLocation?: string;
  sourcePath?: string;
  targetLocation?: string;
  targetPath?: string;
  state: DeliveryState;
  statusMessage?: string;
  fileTransfers?: FileTransfer[];
  startTime?: string;
  endTime?: string;
}

export const transformDeliveryToDisplay = (delivery: Delivery, _locations: Location[]): DeliveryDisplay => {
  // Locations are now just strings (names) from the API, no transformation needed
  return delivery;
};

export interface CreateImmediateDeliveryRequest {
  sourceLocation: string;
  sourcePath: string;
  targetLocation: string;
  targetPath: string;
  fileMappings?: Record<string, string>;
  preDeliveryAction?: PreDeliveryAction;
  postDeliveryAction?: PostDeliveryAction;
  ignoreEmptySource?: boolean;
  retryConfig?: RetryConfig;
  executionMode?: ExecutionMode;
}

export interface ListDeliveriesParams {
  parent?: string;
  pageSize?: number;
  pageToken?: string;
  filter?: string;
  orderBy?: string;
}

export interface ListDeliveriesResponse {
  deliveries: Delivery[];
  nextPageToken?: string;
  totalSize: number;
}

export interface GetDeliveryResponse {
  delivery: Delivery;
}

export interface CancelDeliveryResponse {
  delivery: Delivery;
}
